module.exports = __webpack_public_path__ + "static/media/takeaway.bc5ff239.svg";